import { Upload } from "@progress/kendo-react-upload";
import React, { useContext, useState } from 'react';
import { AppContext } from '../../App';
import { getMediaFilePath } from '../../functions/get-media-file-path';

const UploadField = ({ label, name, defaultFile, onChange, setValue, rules, error, register }) => {
    const [uploadId, setUploadId] = useState(null);
    const appContext = useContext(AppContext);
    const [files, setFiles] = useState([]);
    const inputFieldName = name + "_file";
    const reg = register ? {...register(inputFieldName, rules)} : null;
    if (reg && !reg.value && defaultFile) {
        reg.value = defaultFile;
    }

    const previewFile = getMediaFilePath(defaultFile);

    const removePreview = () => {
        setValue(name + ".remove", true);
    }
    
    return (
        <div className='mb-3 flex flex-grow'>
            <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>{label}:</label>
            <div className='flex flex-col w-full max-w-xs'>                
                <Upload
                saveField="file"
                batch={true}
                multiple={false}
                defaultFiles={files}
                withCredentials={true}
                saveUrl={`${appContext.apiBaseUrl}/fileupload`}
                removeUrl={`${appContext.apiBaseUrl}/fileupload/remove/${uploadId}`}
                onStatusChange ={event => {
                    if (event.newState[0].status == 4 && event.response.status == 200) {
                        setUploadId(event.response.response.uploadId);
                        
                        if (onChange) {
                            onChange({
                                target: {
                                    name,
                                    value: event.response.response.uploadId,
                                    info: event.response.response
                                },
                                resetFiles: () => setFiles([])
                            });
                        }

                        if (setValue) {
                            setValue(name, event.response.response);
                            setValue(inputFieldName, event.response.response.uploadId);
                        }

                        if (reg) {
                            reg.onChange({
                                target: {
                                    name: inputFieldName,
                                    value: event.response.response.uploadId
                                }
                            });
                        }
                    }
                }}
                onRemove={event => {
                    if (event.response.status == 200) {
                        setUploadId(null);        
                        
                        if (onChange) {
                            onChange({
                                target: {
                                    name,
                                    value: null,
                                    info: {}
                                }
                            });
                        }

                        if (setValue) {
                            setValue(name, null);
                            setValue(inputFieldName, null);
                        }

                        if (reg) {
                            reg.onChange({
                                target: {
                                    name: inputFieldName,
                                    value: null
                                }
                            });
                        }
                    }
                }}
                />
                {previewFile?.url && previewFile?.label && !previewFile.remove && (
                    <div className="flex justify-between bg-uiUpload p-3 text-xs border-solid border border-t-0 border-uiUploadBorder">
                        <a href={previewFile?.url} target="_blank">
                            <span className='block text-kenticoblue underline'>{previewFile?.label}</span>
                        </a>
                        <a className="cursor-pointer" onClick={removePreview}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                            </svg>
                        </a>
                    </div>
                )}
                {reg && rules && rules.required && <input type="text" {...reg} style={{display: "none"}} /> }
                {error && <span className='text-red text-xs'>{error}</span>}
            </div>
        </div>
    )
};

export default UploadField;